<template>
    <div class="select-wrapper" v-click-outside="setClose">
        <ui-collapsible @open="setFocus" @close="setClose">
            <div slot="header" class="sitesListFilter">
                {{headerLabel}}: <span v-if="selected.length">{{selected.length}} selected</span>
            </div>
            <div class="select-header"></div>
            <div class="select-actions">
                <div class="search-wrapper">
                    <input type="text" name="search" class="search-input" placeholder="Search" v-model="selectSearch" autocomplete="off" ref="search">
                </div>
                <div class="actions-wrapper">
                    <div class="select-all-action-wrapper">
                        <a class="select-all" @click="selectAllOptions">Select all</a>
                    </div>
                    <div class="clear-all-action-wrapper">
                        <a class="clear-all" @click="clearAllOptions">Clear all</a>
                    </div>
                </div>
            </div>
            <div class="select-body-wrapper">
                <div class="select-body">
                    <div class="control-group select-body" v-bind:class="{'two-columns-layout': twoColumns}">
                        <label class="control control-checkbox" v-for="item in items" :title="item[titleItem]">
                            {{item[optionValue]}}
                            <input type="checkbox" :value="item[optionId]" v-model="selected" :key="item[optionId]"/>
                            <div class="control_indicator"></div>
                        </label>
                    </div>
                </div>
            </div>
            <div class="delimiter"></div>
            <div class="select-actions-buttons" v-if="!withoutButtons">
                <button class="cancel-action" @click="clearFilter()">Cancel</button>
                <button class="apply-action" @click="applyFilter()">Apply</button>
                <div class="clear"></div>
            </div>
        </ui-collapsible>
    </div>
</template>

<script>

    import 'keen-ui/src/bootstrap';
    import UiCollapsible from 'keen-ui/lib/UiCollapsible.min.js';

    export default {
        name: "cc-filter-select",
        components: {
            UiCollapsible
        },
        props: {
            options: {
                type: Array,
                required: true
            },
            selectedOptions: {
                type: Array,
                required: true
            },
            optionId: {
                type: String,
                required: true
            },
            optionValue: {
                type: String,
                required: true
            },
            optionAbbr: {
                type: String,
                required: false,
            },
            headerLabel: {
                type: String,
                required: true
            },
            actionEvent: {
                type: Function,
                required: false
            },
            removeEvent: {
                type: Function,
                required: false
            },
            twoColumns: {
                type: Boolean,
                required: false
            },
            withoutButtons: {
                type: Boolean,
                required: false
            },
            applyType: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                selected: [],
                selectSearch: null,
                originalOptions: null,
                titleItem: null,
                isOpened: false,
                isChanged: false
            }
        },
        computed: {
            items: function(){

                let options = this.options;
                let optionValue = this.optionValue;
                let checkedItems = [];

                if (this.selectedOptions.length > 0 && !this.isChanged)
                {
                    for (var id of this.selectedOptions)
                    {
                        let itemPosition = options.findIndex(function(item){
                            return item.id == id;
                        });

                        if (itemPosition !== -1)
                        {
                            let itemData = options[itemPosition];

                            checkedItems.push(itemData);
                            options.splice(itemPosition, 1);
                        }
                    }
                }

                if (checkedItems.length > 0)
                {
                    checkedItems.sort(function(a, b){
                        let nameA = a[optionValue].toLowerCase();
                        let nameB = b[optionValue].toLowerCase();

                        if (nameA > nameB)
                        {
                            return -1;
                        }
                        else
                        {
                            return 1;
                        }

                        return 0;
                    });

                    for (var itemData of checkedItems)
                    {
                        options.unshift(itemData);
                    }
                }

                if (this.selectSearch != null)
                {
                    let search = this.selectSearch.toLowerCase()

                    options = options.filter(item => {
                        return (
                            item[this.optionValue].toLowerCase().includes(search)
                            ||
                            item[this.optionId].toString().toLowerCase() == search
                            ||
                            (this.optionAbbr && item[this.optionAbbr].toLowerCase().includes(search))
                        );
                    });
                }

                return options;
            }
        },
        created: function(){
            this.titleItem = this.optionAbbr ? this.optionAbbr : this.optionValue;
        },
        mounted: function() {
            this.selected = this.selectedOptions;
        },
        watch: {
            selectSearch: function(newValue){},
            selectedOptions: function(value){
                this.selected = this.selectedOptions;
            },
            selected: function(value){
              if (this.withoutButtons)
              {
                  this.isChanged = true;
                  this.$emit('applyOptions', {'type': this.applyType, 'value': value});
              }
            },
        },
        methods: {
            selectAllOptions: function(){
                this.selected = this.items.map(item => item[this.optionId]);

                if (this.withoutButtons)
                {
                    this.applyFilter();
                }
            },
            clearAllOptions: function(){
                this.selected = [];

                if (this.withoutButtons)
                {
                    this.applyFilter();
                }
            },
            clearFilter: function(){
                this.selected = [];
                this.$children[0].isOpen = false;

                if (this.withoutButtons)
                {
                    this.applyFilter();
                }
            },
            applyFilter: function(){

                if (!this.withoutButtons)
                {
                    this.$children[0].isOpen = false;
                }

                if( this.actionEvent ) {
                    this.actionEvent(this.selected);
                }

                if( this.onApply ) {
                    this.$emit('apply', this.selected);
                }

                if (this.removeEvent !== undefined && this.selected.length === 0)
                {
                    this.removeEvent(this.selected);
                }
            },
            setFocus: function () {
                this.$refs.search.focus();

                this.isOpened = true;
            },
            setClose: function(){
                this.isOpened = false;
                this.isChanged = false;

                if (this.withoutButtons)
                {
                    this.$children[0].isOpen = false;
                }
            }
        }
    }
</script>

<style lang="scss">

    .actions-wrapper {
        display: flex;
        justify-content: space-between;
        align-self: center;
        align-content: center;
        align-items: center;
        margin-top: 5px;

        & > .select-all-action-wrapper {
            .select-all {
                font-size: 12px;
                color: #0051ff;
                cursor: pointer;
            }
        }

        .clear-all-action-wrapper {
            .clear-all {
                font-size: 12px;
                color: #0051ff;
                cursor: pointer;
            }
        }
    }

    .select-body-wrapper {
        /*height: 150px;*/
        overflow: auto;
        padding-right: 25px;
        clear: both;
        max-height: 270px;
    }

    .search-wrapper {
        input.search-input {
            width: 100%;
            padding: 5px 15px 5px 22px;
            border: 1px solid $border-color;
            border-radius: 3px;
            background-image: url('/static/img/filters-search-icon.svg');
            background-repeat: no-repeat;
            background-position: 5px;
            background-size: 1em 1em;
        }
    }

    .select-actions-buttons {
        margin-top: 10px;
    }

    .select-actions {
        margin-bottom: 10px;
    }

    .select-body-wrapper::-webkit-scrollbar-track
    {
        border-radius: 8px;
        background-color: #F5F5F5;
    }

    .select-body-wrapper::-webkit-scrollbar
    {
        width: 8px;
        height: 8px;
        background-color: #F5F5F5;
    }

    .select-body-wrapper::-webkit-scrollbar-thumb
    {
        border-radius: 4px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #868686;
        height: 55%;
    }

    .ui-collapsible {
        min-width: 280px !important;

        .ui-collapsible__header {
            padding: 5px 10px 5px 10px;
            margin: 0;
            font-size: 14px;
            background-color: #fff;
            border-radius: 5px;
            min-height: 0;

            .ui-ripple-ink {
                border: 1px solid #eeeeee;
            }
        }
    }

    .ui-collapsible.is-open {
        .ui-collapsible__header {
            .ui-ripple-ink {
                border-bottom: none;
            }
        }

        .filters-wrapper {
            border: 1px solid $border-color;
            border-radius: $border-radius;
            box-shadow: 1px 3px 7px 1px #cbcccd;
        }
    }

    div.ui-collapsible__body {
        border-top: 0;
        padding: 0.5rem;
    }

    .ui-collapsible:not(.is-disabled) {
        .ui-collapsible__header:hover {
            background-color: #fff;
        }
    }

    .apply-action {
        width: 90px;
        font-size: 14px;
        float: right;
        text-align: center;
        font-weight: bold;
        color: #fff;
        background-color: #4a90e2;
        padding: 10px 0;
        border: 1px solid #3376c5;
        border-radius: 3px;
    }

    .cancel-action {
        width: 90px;
        background-color: #fff;
        font-size: 14px;
        float: left;
        color: #676767;
        padding: 10px 0;
        border: 1px solid #d7d7d7;
        border-radius: 3px;
        text-align: center;
        font-weight: bold;
    }

    .ui-collapsible__body-wrapper {
        position: absolute;
        background: white;
        z-index: 10;
        width: 100%;
    }

    .ui-collapsible {
        position: relative;
    }

    .ui-collapsible.is-open {
        /*border: 1px solid $border-color;
        border-radius: $border-radius;*/
        box-shadow: 0px 8px 7px 1px #cbcccd;

        .ui-collapsible__header {
            border-radius: 5px 5px 0 0;
        }

        .ui-collapsible__body {
            border-bottom:0px;
        }

        .ui-collapsible__body-wrapper {
            box-shadow: 0px 8px 7px 1px #cbcccd;
            border-radius: 0px 0px 5px 5px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/common/CCFilterSelect.vue